import { all } from 'redux-saga/effects';
import { userSagas } from '../modules/Users/sagas';

export default function* rootSaga() {
  yield all([...userSagas]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js